
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Die beginnende dritte Welle`}</h2>
    <p>{`Für die beginnende dritte Welle sind die Fallzahlen vom 25. Februar bis zum 13. April 2021 berücksichtigt. Die geografische Auswertung zeigt, dass nach wie vor Teile der Romandie höhere Infektionszahlen pro Kopf haben. Ein neues Cluster bildet sich aber insbesondere in Uri.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;